import { Cover } from '../primitives';
import { localizedField } from '../../locales/content';
import { hapticImpact } from '../../utils/haptics';

/**
 * PresetCard — одна карточка пресета в группе.
 *
 * Figma source: `318:4669` cover в cards grid, portrait card,
 * cornerRadius 16. Это тот же `cover` component-set (123:2927), что на
 * Home/Catalog — но с portrait-геометрией 179×239 вместо 160×160 1:1.
 *
 * Реализация = `<Cover>` primitive с override geometry через className +
 * style (spec §1 для preset-card: portrait ratio, rounded-home-16).
 * NewBadge включается через `isNew` prop primitive — сам позиционирует
 * top-0 right-0 по Figma constraint (не дублируем здесь).
 *
 * Tap → `onTap(preset)` (полный объект передаётся дальше в PresetsGrid,
 * оттуда — в PresetGroupDetail → navigate('/prompt/:presetId')).
 *
 * Props:
 *   - preset  — { id, image, isNew?, ... }
 *   - onTap   — (preset) => void
 */
export default function PresetCard({
  preset,
  onTap,
  eager = false,
  coverUrl,
  aspectRatio = '3 / 4',
  className = '',
}) {
  const name = localizedField(preset, 'name') || preset?.name || '';
  return (
    <button
      type="button"
      onClick={() => {
        hapticImpact('light');
        onTap(preset);
      }}
      className={['w-full rounded-home-16 overflow-hidden', className].filter(Boolean).join(' ')}
      style={{ aspectRatio }}
      aria-label={name}
    >
      <Cover
        coverUrl={coverUrl || preset.image}
        alt={name}
        isNew={!!preset.isNew}
        eager={eager}
        className="!w-full !h-full !rounded-home-16"
      />
    </button>
  );
}
